import { GamesPromotionStatus } from '@interfaces/IPromotionGames';

export const chooseStatusText = (status: GamesPromotionStatus, content: Record<string, string>) => {
  const { ACTIVE, PLANNED, ENDED } = GamesPromotionStatus;
  const { status_active, status_planned, status_ended, status_error } = content;

  switch (status) {
    case ACTIVE:
      return status_active;
    case PLANNED:
      return status_planned;
    case ENDED:
      return status_ended;
    default:
      return status_error;
  }
};

export const chooseStatusColor = (status: GamesPromotionStatus) => {
  const { ACTIVE, PLANNED, ENDED } = GamesPromotionStatus;
  switch (status) {
    case ACTIVE:
      return 'blue';
    case PLANNED:
      return 'orange';
    case ENDED:
      return 'success';
    default:
      return 'error';
  }
};

export const promotionIsActive = (status: GamesPromotionStatus) => {
  return status === GamesPromotionStatus.ACTIVE;
};

export const allowEdit = (status: GamesPromotionStatus) => {
  const { PLANNED, ERROR } = GamesPromotionStatus;
  return status === PLANNED || status === ERROR;
};
